module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0078.jpg?v=ca2312df";